import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/BackgroundAsImage.js";
import Features from "components/features/VerticalWithAlternateImageAndText.js";
import Footer from "components/footers/MiniCenteredFooter";

export default () => (
  <AnimationRevealPage>
    <Hero />
    <Features />
    <Footer />
  </AnimationRevealPage>
);
